import { siteData } from "../data/mock";
import { Award, Shield, Sparkles, Heart } from "lucide-react";

export const AboutSection = () => {
  return (
    <section id="sobre" className="py-20 bg-gradient-to-br from-slate-50 to-blue-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img
                src={siteData.images.childPhoto}
                alt="Dra. Giovana com paciente"
                className="w-full h-[480px] object-cover"
              />
            </div>
            {/* Floating badge */}
            <div
              className="absolute -bottom-5 -right-3 sm:right-6 bg-white rounded-xl shadow-lg p-4 flex items-center gap-3 border-2"
              style={{ borderColor: '#85BCFF' }}
            >
              <div className="w-10 h-10 rounded-lg flex items-center justify-center" style={{ backgroundColor: 'rgba(133, 188, 255, 0.15)' }}>
                <Sparkles size={20} style={{ color: '#85BCFF' }} />
              </div>
              <div>
                <p className="text-sm font-bold text-slate-900">Ortopedia Kids</p>
              </div>
            </div>
          </div>

          {/* Content */}
          <div>
            <span className="text-sm font-semibold uppercase tracking-wider mb-3 block" style={{ color: '#85BCFF' }}>
              Sobre
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4 leading-tight">
              Dra. {siteData.about.name}
            </h2>

            <div className="flex flex-wrap gap-2 mb-6">
              <span className="px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700">
                {siteData.about.title}
              </span>
              <span className="px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700">
                {siteData.about.location}
              </span>
              {siteData.about.credentials.map((cred, idx) => (
                <span key={idx} className="px-3 py-1 rounded-full text-xs font-semibold bg-blue-50 text-blue-700">
                  {cred}
                </span>
              ))}
            </div>

            <p className="text-base text-slate-600 mb-8 leading-relaxed">
              {siteData.about.message}. Com dedicação à odontologia e atualização constante, a Dra. Giovana oferece tratamentos personalizados com o que há de mais moderno em tecnologia odontológica.
            </p>

            {/* Stats grid */}
            <div className="grid grid-cols-2 gap-4">
              {[
                { icon: Award, title: "Credibilidade", desc: "Formação de excelência" },
                { icon: Shield, title: "Inovação", desc: "Tecnologia avançada" },
                { icon: Heart, title: "Cuidado", desc: "Atendimento humanizado" },
                { icon: Sparkles, title: "Qualidade", desc: "Resultados excepcionais" },
              ].map((item, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-3 p-4 bg-white rounded-xl border border-slate-100 hover:border-[#85BCFF] transition-colors"
                >
                  <div className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0" style={{ backgroundColor: 'rgba(133, 188, 255, 0.12)' }}>
                    <item.icon size={18} style={{ color: '#85BCFF' }} />
                  </div>
                  <div>
                    <p className="text-sm font-bold text-slate-900">{item.title}</p>
                    <p className="text-xs text-slate-500">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
